import type { EligiblePanel, EligiblePanelApiResponse } from '@/types/auth';

// ─── Paneles elegibles ────────────────────────────────────────────────────────
// Mapeo y presentación de los paneles a los que un admin tiene acceso. Separado
// de `pendingLogin.ts`, que solo se ocupa de guardar el login a medio terminar.

// El `name` llega con espacios al final en datos reales ("Moisés Berenguer "),
// así que se normaliza acá una vez, en la frontera con la API, en lugar de hacer
// `.trim()` en cada lectura.
export const mapEligiblePanelApiToEligiblePanel = (
  raw: EligiblePanelApiResponse,
): EligiblePanel => ({
  corporateId: raw.corporate_id ?? '',
  isOwner: raw.is_owner ?? false,
  name: raw.name?.trim() ?? '',
});

/**
 * Segunda línea de la fila. El diseño pide el rol del usuario en el panel, pero
 * la API no lo manda: lo único que devuelve sobre la relación es `is_owner`, así
 * que se muestra la propiedad y no un rol inventado.
 */
export const getPanelOwnershipLabel = (panel: EligiblePanel): string =>
  panel.isOwner ? 'Propietario' : 'Operador';
